'use client';

import * as React from 'react';
import type { Control, FieldValues, Path } from 'react-hook-form';
import { Controller } from 'react-hook-form';

import { RadioGroup, type RadioGroupProps } from '@packages/shared/src/ui/RadioGroup/RadioGroup';

export interface ControlledRadioGroupProps<T extends FieldValues = FieldValues>
  extends RadioGroupProps {
  control: Control<T>;
  controllerName: Path<T>;
}

const ControlledRadioGroup = React.forwardRef(
  <T extends FieldValues>(
    { children, control, controllerName, ...props }: ControlledRadioGroupProps<T>,
    ref: React.Ref<React.ElementRef<typeof RadioGroup>>,
  ) => (
    <Controller
      control={control}
      name={controllerName}
      render={({ field }) => (
        <RadioGroup {...props} {...field} ref={ref} onValueChange={field.onChange}>
          {children}
        </RadioGroup>
      )}
    />
  ),
) as (<T extends FieldValues = FieldValues>(
  props: ControlledRadioGroupProps<T> & {
    ref?: React.Ref<React.ElementRef<typeof RadioGroup>>;
  },
) => React.ReactElement) & { displayName?: string };

ControlledRadioGroup.displayName = 'ControlledRadioGroup';

export { ControlledRadioGroup };
